var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.584 8.559c-.032.122-.066.242-.102.361"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "0.7299,0.9732",
    d: "M16.154 9.839c-.785 1.871-2.126 3.189-4.039 3.189-2.065 0-3.464-1.535-4.215-3.645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.749 8.92c-.036-.119-.07-.239-.102-.361"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M1.623 1.478h3.711v5.274H1.623z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.364 3.49h-.005l-.349.166-.07-.32.483-.225h.354v1.825h-.413V3.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M12.846 11.317h3.711v5.274h-3.711z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.119 14.358c.076.039.25.112.424.112.222 0 .334-.107.334-.245 0-.18-.18-.261-.368-.261h-.174v-.306h.166c.143-.003.326-.057.326-.211 0-.109-.09-.19-.27-.19-.149 0-.306.064-.382.109l-.087-.31c.11-.069.329-.137.564-.137.391 0 .606.205.606.454 0 .194-.109.346-.334.425v.005c.219.04.396.205.396.444 0 .322-.284.559-.747.559-.236 0-.435-.062-.542-.13l.088-.318z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M12.07 1.478h3.711v5.274H12.07z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.267 4.937v-.259l.235-.213c.399-.356.593-.562.598-.775 0-.148-.09-.267-.3-.267-.157 0-.295.079-.39.152l-.12-.306c.137-.104.351-.188.598-.188.413 0 .64.241.64.572 0 .306-.222.551-.486.786l-.168.141v.006h.688v.351h-1.295z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M18.666 1.478h3.711v5.274h-3.711z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.618 4.937v-.436h-.809v-.277l.691-1.113h.522v1.07h.219V4.5h-.219v.436h-.404zm0-.755v-.405c0-.109.006-.223.014-.34h-.011c-.059.117-.106.225-.168.34l-.244.398v.006h.409z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M19.585 19.331h-1.65l1.146 2.73-.916.384-1.145-2.73-1.238 1.226v-5.398z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizSorting);
export default __webpack_public_path__ + "static/media/quiz_sorting.fa0a4034f5a9034fc9fdbc0e8c30ba0a.svg";
export { ForwardRef as ReactComponent };